import dayjs from 'dayjs';
import { BankListDescription } from 'constants/banksList';
import {
	DestinationKeyTypeDescription,
	DestinationTypeDescription,
} from 'constants/destination';
import { normalizeBankAccount } from 'helpers/normalizers';
import { EscrowDestinationsFiltersType } from './EscrowDetailsAccountDestination.types';
import {
	FilterChip,
	FilterChipsContainer,
} from './EscrowDetailsAccountDestination.styles';

// as duas datas viram um chip so, entao a chave nao e a do filtro
export type FilterChipKey =
	| keyof Omit<
			EscrowDestinationsFiltersType,
			'created_at_start_date' | 'created_at_end_date'
	  >
	| 'created_at';

type FilterChipItem = {
	key: FilterChipKey;
	label: string;
	value: string;
};

const formatDate = (date?: string | null): string | undefined => {
	if (!date) {
		return undefined;
	}

	const parsed = dayjs(date);

	return parsed.isValid() ? parsed.format('DD/MM/YYYY') : undefined;
};

const buildChips = (
	filters: EscrowDestinationsFiltersType,
): FilterChipItem[] => {
	const chips: FilterChipItem[] = [];

	const push = (key: FilterChipKey, label: string, value?: string) => {
		if (value) {
			chips.push({ key, label, value });
		}
	};

	push('search', 'Beneficiário', filters.search);
	push('id', 'ID', filters.id);
	push(
		'account',
		'Nº da conta',
		filters.account ? normalizeBankAccount(filters.account) : undefined,
	);
	push(
		'bank',
		'Banco',
		filters.bank
			? BankListDescription[filters.bank] || filters.bank
			: undefined,
	);
	push('branch', 'Agência', filters.branch?.padStart(4, '0'));
	push(
		'type',
		'Tipo de conta',
		filters.type
			? DestinationTypeDescription[filters.type] || filters.type
			: undefined,
	);
	push(
		'key_type',
		'Chave Pix',
		filters.key_type
			? DestinationKeyTypeDescription[filters.key_type] ||
					filters.key_type
			: undefined,
	);
	push('creator', 'Criador do beneficiário', filters.creator);

	const startDate = formatDate(filters.created_at_start_date);
	const endDate = formatDate(filters.created_at_end_date);

	if (startDate || endDate) {
		push(
			'created_at',
			'Data de cadastro',
			startDate && endDate && startDate !== endDate
				? `${startDate} a ${endDate}`
				: startDate || endDate,
		);
	}

	return chips;
};

interface IEscrowDetailsAccountDestinationFilterChipsProps {
	filters: EscrowDestinationsFiltersType;
	onRemove: (key: FilterChipKey) => void;
}

const EscrowDetailsAccountDestinationFilterChips = ({
	filters,
	onRemove,
}: IEscrowDetailsAccountDestinationFilterChipsProps) => {
	const chips = buildChips(filters);

	if (chips.length === 0) {
		return null;
	}

	return (
		<FilterChipsContainer>
			{chips.map(chip => (
				<FilterChip
					key={chip.key}
					closable
					onClose={event => {
						event.preventDefault();
						onRemove(chip.key);
					}}
				>
					{/* um unico no: o chip e flex e descartaria o espaco */}
					<span>
						<strong>{`${chip.label}:`}</strong>
						{` ${chip.value}`}
					</span>
				</FilterChip>
			))}
		</FilterChipsContainer>
	);
};

export default EscrowDetailsAccountDestinationFilterChips;
